import * as angular from "angular";
import {IController} from "angular";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";

export class resourceColorCtrl implements IController {

  id: string;

  private color: string;

  /* @ngInject */
  constructor(private commonsDialogService: CommonsDialogService, private commonsService: CommonsService) {
  }

  $onInit() {
    this._setColorById(this.id);
  };

  $onChanges(changes) {
    if (changes.id && !changes.id.isFirstChange()) {
      this._setColorById(this.id);
    }
  }

  _setColorById(id) {
    this.color = this.commonsService.getColorById(id);
  }

}

angular
  .module('bringoz.admin.resources')
  .component('resourceColor', {
    bindings: {
      id: '<'
    },
    template: require('./resource-color.html').default,
    controller: resourceColorCtrl
  });
